import React from 'react';
import styles from './IndividualCard.module.css';
import { useNavigate, useLocation } from 'react-router-dom';

interface IndividualCardProps {
  reference: string;
  verses: string;
  explanation?: string;
  date?: string;
}

const IndividualCard: React.FC<IndividualCardProps> = ({ reference, verses, explanation, date }) => {
  // Function to truncate text to a specific number of words
  const truncateText = (text: string, wordLimit: number): string => {
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  // Truncate verses to 14 words
  const truncatedVerses = truncateText(verses, 14);
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // Determine the correct path based on the current location
    if (location.pathname === '/hymns') {
      // For hymns, navigate to the detail page
      navigate(`/hymns/${encodeURIComponent(reference)}`);
    } else if (location.pathname === '/salvation') {
      // For salvation, navigate to the detail page
      navigate(`/salvation/${encodeURIComponent(reference)}`);
    } else if (location.pathname === '/armor-of-god') {
      // For armor of god, navigate to the detail page
      navigate(`/armor-of-god/${encodeURIComponent(reference)}`);
    } else if (location.pathname === '/safety-verses') {
      // For safety verses, navigate to the detail page
      // Note: The parent component handles this navigation directly
      // This is just a fallback
      const id = reference.toLowerCase().replace(/\s+/g, '-').replace(/:/g, '');
      navigate(`/safety-verses/${encodeURIComponent(id)}`);
    }
  };

  return (
    <div className={styles['individual-card']} onClick={handleClick}>
      <div>
        <h3 className={styles['verse-reference']}>{reference}</h3>
        <div className={styles['spacer']}></div>
        {date && <p className={styles['verse-date']}>{date}</p>}
        <div className={styles['spacer']}></div>
        <div className={styles['verse-content']}>
          <p className={styles['verse-text']}>{truncatedVerses}</p>
        </div>
      </div>
    </div>
  );
};

export default IndividualCard;
